import React, { useContext, Suspense, lazy } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import NotFound from '../pages/not-found/NotFound';
import Login from '../pages/login/Login';
import SuperAdminHome from '../pages/super-admin/Home';
import SuperAdminFeed from '../pages/super-admin/Feed';
import SuperAdminUsers from '../pages/super-admin/Admins';
import SuperAdminAds from '../pages/super-admin/Ads';
import SuperAdminUpdates from '../pages/super-admin/Updates';
import AdminHome from '../components/Home';
import Loader from '../components/loader/Loader';
import SuperAdminBreakingNews from '../pages/super-admin/Breakingnews';
import Polls from '../pages/super-admin/Polls';
import Users from '../pages/super-admin/Users';
import Meetings from '../pages/super-admin/Meetings';
import PushNotification from '../pages/super-admin/PushNotification';
import Packages from '../pages/super-admin/Packages';
import Transactions from '../pages/super-admin/Transactions';
import AuditLog from '../pages/super-admin/AuditLog';
import FailedLogins from '../pages/super-admin/FailedLogins';
import PushHistory from '../pages/super-admin/PushHistory';
import Reports from '../pages/super-admin/Reports';
import CrashReports from '../pages/super-admin/CrashReports';
import AppConfig from '../pages/super-admin/AppConfig';




const AppRoutes = () => {
    const { isAuthenticated, user, loading } = useContext(AuthContext);


    if (loading) {
        return (
            <>
                <div className="flex h-screen w-full items-center justify-center bg-gray-100 ">
                    <Loader />
                </div>
            </>
        )
    }


    return (
        <Routes>

            {
                !isAuthenticated ? (
                    <>
                        <Route path="/" element={<Navigate to="/login" />} />
                        <Route path="/login" element={<Login />} />
                    </>
                )
                    :
                    isAuthenticated && user.isSuperAdmin ?
                        (
                            <>

                                <Route path="/" element={<Navigate to="/super-admin/home" />} />
                                <Route path="/login" element={<Navigate to="/super-admin/home" />} />

                                <Route path="/super-admin/home" element={<SuperAdminHome />} />
                                <Route path="/super-admin/feeds" element={<SuperAdminFeed />} />
                                <Route path="/super-admin/admins" element={<SuperAdminUsers />} />
                                <Route path="/super-admin/ads" element={<SuperAdminAds />} />
                                <Route path="/super-admin/users" element={<Users />} />
                                <Route path="/super-admin/updates" element={<SuperAdminUpdates />} />
                                <Route path="/super-admin/breakingnews" element={<SuperAdminBreakingNews />} />
                                <Route path="/super-admin/polls" element={<Polls />} />
                                <Route path="/super-admin/meetings" element={<Meetings />} />
                                <Route path="/super-admin/push-notifications" element={<PushNotification />} />
                                <Route path="/super-admin/packages" element={<Packages />} />
                                <Route path="/super-admin/transactions" element={<Transactions />} />
                                <Route path="/super-admin/audit-log" element={<AuditLog />} />
                                <Route path="/super-admin/failed-logins" element={<FailedLogins />} />
                                <Route path="/super-admin/push-history" element={<PushHistory />} />
                                <Route path="/super-admin/reports" element={<Reports />} />
                                <Route path="/super-admin/crash-reports" element={<CrashReports />} />
                                <Route path="/super-admin/app-config" element={<AppConfig />} />
                            </>
                        )
                        :
                        <>
                            <Route path="/" element={<Navigate to="/admin/home" />} />
                            <Route path="/login" element={<Navigate to="/admin/home" />} />

                            <Route path="/admin/home" element={<AdminHome />} />

                            {
                                user.permission.map((item, index) => {

                                    const ComponentName = lazy(() => import(`../pages/super-admin/${item.charAt(0).toUpperCase() + item.slice(1)}`));

                                    return (
                                        <Route
                                            key={index}
                                            path={`/admin/${item}`}
                                            element={
                                                <Suspense fallback={<div>Loading...</div>}>
                                                    <ComponentName />
                                                </Suspense>
                                            }
                                        />
                                    );
                                })
                            }

                            {/* <Route path="/admin/feeds" element={<SuperAdminFeed />} />
                            <Route path="/admin/users" element={<SuperAdminUsers />} />
                            <Route path="/admin/ads" element={<SuperAdminAds />} />
                            <Route path="/admin/updates" element={<SuperAdminUpdates />} /> */}
                        </>
            }

            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default AppRoutes;
